<template>
  <section class="all-cases-view" id="all-sendOuts-list">
    <div class="navbarComponent">
      <div class="container-default">
        <div class="listings-navbar">
          <el-row>
            <el-col :lg="7">
              <ul class="d-flex list-items-group-15 barcode-print">
                <li>
                  <div class="form-element input-with-icon search-input-lg has-search-shortcut">
                    <el-input
                      ref="searchShortcutInput"
                      placeholder="SendoutId / Patient Name"
                      v-model="search_string"
                      @input="getAutoCompleteOrders()"
                      :clearable="true"
                    ></el-input>
                    <span v-if="!search_string" class="search-shortcut-hint"><kbd v-for="key in searchShortcutKeys" :key="key">{{ key }}</kbd></span>
                  </div>
                </li>
              </ul>
            </el-col>
            <el-col :lg="17">
              <ul
                class="d-flex flex-wrap justify-content-end list-items-group-15"
              >
                <li>
                  <div class="search-with-date-input">
                    <el-date-picker
                      format="MM-DD-YYYY"
                      v-model="date_of_birth"
                      :disabled-date="disabledDate"
                      @change="fetchAllSendOuts()"
                      placeholder="Patient DOB"
                      :clearable="true"
                    ></el-date-picker>
                  </div>
                </li>
                <li>
                  <div class="search-with-date-input">
                    <el-date-picker
                      v-model="fromDate"
                      type="date"
                      placeholder="From Date"
                      format="MM-DD-YYYY"
                      :clearable="true"
                      :disabled-date="disabledFromDate"
                      @change="onFromDateChange"
                      value-format="YYYY-MM-DD"
                      style="width: 100%"
                    />
                  </div>
                </li>
                <li>
                  <div class="search-with-date-input">
                    <el-date-picker
                      v-model="toDate"
                      type="date"
                      placeholder="To Date"
                      format="MM-DD-YYYY"
                      :clearable="true"
                      value-format="YYYY-MM-DD"
                      :disabled-date="disabledToDate"
                      style="width: 100%"
                      @change="handleCurrentChange(1)"
                    />
                  </div>
                </li>
                <li>
                  <el-button
                    class="btn button-with-icon"
                    @click="onReportsExport"
                  >
                    <span class="mr-8">
                      <img
                        src="@/assets/images/icons/export-icon-with-bg-blue.svg"
                        alt="icon"
                        class="inactive"
                      />
                      <img
                        src="@/assets/images/icons/export-icon-white.svg"
                        alt="icon"
                        class="active"
                      />
                    </span>
                    <span>Export</span>
                  </el-button>
                </li>
                <li>
                  <el-button
                    class="filter-toggle-btn"
                    @click="showFilters = !showFilters"
                  >
                    {{ showFilters ? 'Hide Filters' : 'Show Filters' }}
                  </el-button>
                </li>
                <li>
                  <el-button class="filter-clear-btn" @click="clearAllFilters">
                    Clear Filters
                  </el-button>
                </li>
                <li v-if="showFilters">
                  <el-popover
                    placement="bottom-end"
                    :width="250"
                    trigger="click"
                    popper-class="filter-customize-popover"
                  >
                    <template #reference>
                      <el-button class="filter-customize-btn" title="Customize filters">
                        Customize Filters
                      </el-button>
                    </template>
                    <div class="filter-customize-panel">
                      <p class="fc-title">Show / hide &amp; drag to reorder</p>
                      <div
                        v-for="f in customizableFilters"
                        :key="f.key"
                        class="fc-row"
                      >
                        <el-checkbox
                          :model-value="!hiddenFilters.includes(f.key)"
                          @change="toggleFilterVisibility(f.key)"
                        >
                          {{ f.label }}
                        </el-checkbox>
                      </div>
                      <el-button
                        text
                        size="small"
                        class="fc-reset"
                        @click="resetFilterPreferences"
                      >
                        Reset to default
                      </el-button>
                    </div>
                  </el-popover>
                </li>
              </ul>
            </el-col>
          </el-row>
          <transition name="slide-filters">
            <el-row v-if="showFilters" class="mt-10">
              <el-col :span="24">
                <draggable
                  v-model="orderedVisibleFilters"
                  item-key="key"
                  tag="ul"
                  class="d-flex list-items-group-15 filters-draggable"
                  handle=".filter-drag-handle"
                  ghost-class="filter-ghost"
                >
                  <template #item="{ element }">
                    <li class="filter-drag-item">
                      <span class="filter-drag-handle" title="Drag to reorder">⠿</span>
                      <template v-if="element.key === 'ordering_facility'">
                        <div class="form-element search-with-filter-input">
                          <el-select
                            v-model="selectedHospital"
                            placeholder="Ordering Facility"
                            filterable
                            clearable
                            multiple
                            collapse-tags
                            collapse-tags-tooltip
                            :max-collapse-tags="1"
                            :reserve-keyword="false"
                            default-first-option
                            value-key="_id"
                            @change="onHospitalChange"
                            remote
                            @focus="onHospitalFocus"
                            :remote-method="remoteMethodFacility"
                            :loading="hospitalsLoading"
                          >
                            <el-option
                              v-for="hospital in hospitalsData.data"
                              :key="hospital"
                              :label="hospital.name"
                              :value="hospital"
                            ></el-option>
                          </el-select>
                        </div>
                      </template>
                      <template v-else-if="element.key === 'physician'">
                        <div class="form-element search-with-filter-input">
                          <el-select
                            v-model="physician"
                            placeholder="Physician"
                            filterable
                            clearable
                            multiple
                            collapse-tags
                            collapse-tags-tooltip
                            :max-collapse-tags="1"
                            :reserve-keyword="false"
                            default-first-option
                            @change="handleCurrentChange(1)"
                            @focus="onPhysicianFocus"
                            :loading="physiciansLoading"
                            remote
                            :remote-method="remoteMethodPhysician"
                          >
                            <el-option
                              v-for="physician in physiciansData.data"
                              :key="physician"
                              :label="physician.name"
                              :value="physician._id"
                            ></el-option>
                          </el-select>
                        </div>
                      </template>
                      <template v-else-if="element.key === 'case_type'">
                        <div class="form-element search-with-filter-input">
                          <el-select
                            v-model="caseType"
                            placeholder="Case Type"
                            filterable
                            clearable
                            multiple
                            collapse-tags
                            collapse-tags-tooltip
                            :max-collapse-tags="1"
                            default-first-option
                            :reserve-keyword="false"
                            @change="handleCurrentChange(1)"
                          >
                            <el-option
                              v-for="caseType in getAuthenticatedUser.user_type == 'LAB_TECHNOLOGIST' && getAuthenticatedUser.allowed_case_types ? getUserBasedCaseTypes(caseTypes) : getLabBasedCaseTypes(caseTypes)"
                              :key="caseType"
                              :label="caseType.label"
                              :value="caseType.value"
                            ></el-option>
                          </el-select>
                        </div>
                      </template>
                    </li>
                  </template>
                </draggable>
              </el-col>
            </el-row>
          </transition>
        </div>
      </div>
    </div>
    <div class="container-default" style="padding-top: 0">
      <div class="primary-content-view-new" v-loading="loading">
        <div
          class="listings listings__table listings__all-cases"
          id="all-cases-listings"
        >
          <el-table
            :data="getAllSendOuts.data"
            height="calc(100vh - 200px)"
            :default-sort="{
              prop: orderBy,
              order: orderType == 'asc' ? 'ascending' : 'descending',
            }"
            style="width: 100%"
            @sort-change="onChangeSort"
          >
            <el-table-column
              fixed="left"
              prop="sendout_id"
              label="SENDOUT"
              min-width="150"
              sortable="custom"
            >
              <template #default="scope">
                <div class="name-accession">
                  <span id="accession-id" @click="onView(scope.row._id)">{{
                    scope.row.sendout_id
                  }}</span>
                  <div
                    v-if="scope.row.is_stat && !showStatCase()"
                    style="width: 41px; height: 24px; color: #1b2459"
                  >
                    STAT
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              fixed="left"
              prop="accession_id"
              label="ACCESSION ID"
              min-width="130"
              sortable="custom"
            >
              <template #default="scope">
                <template v-if="scope.row.case_id">
                  <div class="name-accession cursor">
                    <span
                      id="accession-id-blue"
                      @click="goToCaseView(scope.row.case_id)"
                      >{{ scope.row.accession_id }}</span
                    >
                  </div>
                </template>
              </template>
            </el-table-column>
            <el-table-column
              label="Case Type"
              min-width="125"
              prop="case_types"
              sortable="custom"
              fixed="left"
            >
              <template #default="scope">
                <div
                  class="case-type"
                  v-if="scope.row.case_types && scope.row.case_types.length > 1"
                >
                  <el-dropdown>
                    <span class="case-data-type">
                      {{ getCaseTypes(scope.row.case_types)[0] }}
                      <img
                        src="@/assets/images/case-type-arrow.svg"
                        alt="icon"
                      />
                    </span>

                    <template #dropdown>
                      <el-dropdown-menu class="case-type-dropdown">
                        <el-dropdown-item
                          class="cases-view"
                          v-for="(caseType, index) of getCaseTypes(
                            scope.row.case_types
                          )"
                          :key="index"
                          >{{ caseType }}</el-dropdown-item
                        >
                      </el-dropdown-menu>
                    </template>
                  </el-dropdown>
                </div>
                <div v-else class="case-type">
                  <span class="case-data-type">{{
                    getCaseTypes(scope.row.case_types)[0]
                  }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="patient_info.first_name"
              label="PATIENT NAME"
              width="160"
              sortable="custom"
              fixed="left"
            >
              <template v-slot="scope">
                <el-button
                  placement="top"
                  class="title-on-hover"
                  :title="
                    convertToUppercase(
                      getPatientNameByInfo(scope.row.patient_info)
                    )
                  "
                  @click="
                    copyTitle(getPatientNameByInfo(scope.row.patient_info))
                  "
                >
                  <span class="text-center ordering_facility-value">{{
                    convertToUppercase(
                      getPatientNameByInfo(scope.row.patient_info)
                    )
                  }}</span>
                </el-button>
              </template>
            </el-table-column>
            <el-table-column
              label="Patient DOB"
              min-width="120"
              prop="date_of_birth"
            >
              <template #default="scope">
                <div style="cursor: default" v-if="scope.row.patient_info">
                  {{ formatDate(scope.row.patient_info.date_of_birth) }}
                </div>
              </template>
            </el-table-column>

            <el-table-column
              prop="hospitals"
              label="ORDERING FACILITIES"
              min-width="215"
            >
              <template #default="scope">
                <el-button
                  placement="top"
                  class="title-on-hover"
                  :title="scope.row.hospital ? scope.row.hospital.name : '--'"
                >
                  <span class="ordering_facility-value">{{
                    scope.row.hospital ? scope.row.hospital.name : "--"
                  }}</span>
                </el-button>
              </template>
            </el-table-column>
            <el-table-column prop="physician" label="physician" min-width="150">
              <template #default="scope">
                <el-button
                  placement="top"
                  class="title-on-hover"
                  :title="
                    /* scope.row.ordering_physician
                      ? scope.row.ordering_physician.name.includes('Dr')
                        ? scope.row.ordering_physician.name
                        : 'Dr ' + scope.row.ordering_physician.name
                      : '--' */
                    scope.row.ordering_physician
                      ? scope.row.ordering_physician.name
                      : '--'
                  "
                >
                  <span class="text-center ordering_facility-value">{{
                    /* scope.row.ordering_physician
                      ? scope.row.ordering_physician.name.includes("Dr")
                        ? scope.row.ordering_physician.name
                        : "Dr " + scope.row.ordering_physician.name
                      : "--" */
                    scope.row.ordering_physician
                      ? scope.row.ordering_physician.name
                      : "--"
                  }}</span>
                </el-button>
              </template>
            </el-table-column>
            <el-table-column
              label="CREATED ON"
              min-width="130"
              prop="created_at"
              sortable="custom"
            >
              <template #default="scope">
                <div v-if="scope.row.created_at">
                  <div class="d-flex">
                    <div class="text-center date pr-5" style="cursor: default">
                      {{
                        momentWithTimezone(scope.row.created_at, "MM-DD-yyyy")
                      }}
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="Received On"
              min-width="130"
              prop="received_date"
              sortable="custom"
            >
              <template #default="scope">
                <div v-if="scope.row.received_date">
                  <div class="d-flex">
                    <div class="date pr-5" style="cursor: default">
                      {{
                        momentWithTimezone(
                          scope.row.received_date,
                          "MM-DD-yyyy"
                        )
                      }}
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="Status"
              min-width="130"
              prop="status"
              sortable="custom"
            >
              <template v-slot="scope">
                <div class="column-status">
                  <span
                    class="el-dropdown-link"
                    v-if="scope.row.status && scope.row.status == 'COMPLETE'"
                  >
                    <el-tag
                      style="cursor: default"
                      :type="getStatusType(scope.row.status)"
                      >FINALIZED</el-tag
                    >
                  </span>
                  <span class="el-dropdown-link" v-else>
                    <el-tag
                      style="cursor: default"
                      :type="getStatusType(scope.row.status)"
                    >
                      {{ scope.row.status.split("_").join(" ") }}
                    </el-tag>
                  </span>
                </div>
              </template>
            </el-table-column>
            <!-- <el-table-column
              prop="cross_lab_status"
              label="Cross Lab Status"
              width="170"
            >
              <template #default="scope">
                <el-tooltip
                  effect="dark"
                  placement="top"
                  :content="
                    scope.row.cross_lab_status === 'INVALID'
                      ? scope.row.rejection_reason
                      : ''
                  "
                >
                  <span class="text-center ordering_facility-value" style="cursor: pointer;">
                    {{ scope.row.cross_lab_status || "--" }}
                  </span>
                </el-tooltip>
              </template>
            </el-table-column> -->
            <el-table-column
              prop="action"
              label="Actions"
              width="150"
              fixed="right"
            >
              <template v-slot="scope">
                <ul class="listings__action-buttons">
                   <li @click="sendoutPrint(scope.row._id)">
                    <el-button class="view-button" title="Print Sendout">
                      <img
                        class="inactive"
                        src="@/assets/images/printer-icon-black.svg"
                        alt="icon"
                      />
                    </el-button>
                  </li>
                  <li @click="onView(scope.row._id)">
                    <el-button class="view-button" title="View Sendout">
                      <img
                        class="action-active"
                        src="@/assets/images/icons/actions/view-icon.svg"
                        alt="icon"
                      />
                      <img
                        class="action-inactive"
                        src="@/assets/images/icons/actions/view-inactive.svg"
                        alt="icon"
                      />
                    </el-button>
                  </li>
                  <li
                    v-if="
                      scope.row.status != 'ARCHIVED' &&
                      scope.row.status == 'COMPLETE' &&
                      checkNewReport(scope.row)
                    "
                  >
                    <el-button
                      title="Test Reports"
                      class="reports-button"
                      @click="onViewReports(scope.row)"
                    >
                      <span class="afterTestReportsIcon">
                        <img
                          src="@/assets/images/icons/actions/afterViewIcon.svg"
                          alt="icon"
                          style="width: 18px"
                        />
                      </span>
                    </el-button>
                  </li>
                  <li
                    v-if="
                      scope.row.status != 'ARCHIVED' &&
                      hasPermission('send_outs', 'create')
                    "
                  >
                    <el-button
                      class="delete-button"
                      @click="onDelete(scope.row._id)"
                      title="Delete Sendout"
                    >
                      <img
                        class="action-active"
                        src="@/assets/images/icons/actions/delete-active.svg"
                        alt="icon"
                      />
                      <img
                        class="action-inactive"
                        src="@/assets/images/icons/actions/delete-deactive.svg"
                        alt="icon"
                      />
                    </el-button>
                  </li>
                </ul>
              </template>
            </el-table-column>
          </el-table>
          <div class="listings listings__pagination">
            <el-pagination
              v-model:currentPage="page"
              v-model:page-size="pageSize"
              :page-sizes="[25, 50, 75, 100]"
              layout="prev, pager, next, jumper, sizes, total"
              :total="getAllSendOuts.total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
    <SendoutsExport
      v-if="exportSendoutsDialogVisisble"
      v-on:close="exportSendoutsDialogVisisble = false"
      :search_string="search_string"
      :search_patient_name="patient_name"
      :search_hospital="(selectedHospital || []).map((h) => h && h._id).filter(Boolean)"
      :search_hospital_names="(selectedHospital || []).map((h) => h && h.name).filter(Boolean)"
      :search_physician="physician"
      :search_dob="date_of_birth"
      :search_caseType="caseType"
      :search_status="selectedStatuses"
      :pregnancy="pregnant"
    >
    </SendoutsExport>
  </section>
</template>

<script>
import { defineAsyncComponent } from "vue";
import { mapGetters } from "vuex";
import moment from "moment";
import caseConstants from "@/config/constants/caseConstants";
import FilterHelper from "@/mixins/FilterHelper";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import exportExcelHelper from "@/mixins/exportExcelHelper";
import {
  sendOutSearchOptions,
  pregnencyOptions,
} from "@/config/constants/searchConstants";
const SendoutsExport = defineAsyncComponent(() =>
  import("@/components/sendOuts/ExportSendOuts")
);
import caseDataHelper from "@/mixins/caseDataHelper";
import FilterPreferencesMixin from "@/mixins/FilterPreferencesMixin";
import SearchShortcutMixin from "@/mixins/SearchShortcutMixin";
import ListRowShortcutsMixin from "@/mixins/ListRowShortcutsMixin";
import draggable from "vuedraggable";
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
export default {
  name: "hospital",
  props: {
    selectedStatuses: {
      default: [],
    },
  },
  components: { SendoutsExport, draggable },
  mixins: [
    FilterHelper,
    UserPermissionsHelper,
    exportExcelHelper,
    caseDataHelper,
    FilterPreferencesMixin,
    SearchShortcutMixin, ListRowShortcutsMixin,
  ],
  rowShortcutNoun: "sendout",
  data() {
    return {
      showFilters: false,
      filterGroupKey: "sendouts",
      filterMeta: [
        { key: "ordering_facility", label: "Ordering Facility" },
        { key: "physician", label: "Physician" },
        { key: "case_type", label: "Case Type" },
      ],
      disabledDate: (time) => {
        return time.getTime() > Date.now();
      },
      scrollPosition: null,
      sendOutExportDialog: false,
      // searchByKey: ["PatientName", "accession_id", "EMR"],
      searchOptions: sendOutSearchOptions,
      pregnencyOptions: pregnencyOptions,
      search_string: "",
      patient_name: "",
      hospital: "",
      date_of_birth: "",
      physician: [],
      searchBy: "",
      caseType: [],
      page: 1,
      pageSize: 25,
      caseTypeMap: caseConstants.CASE_TYPE_MAP,
      caseTypes: caseConstants.CASE_TYPES_DATA,
      loading: false,
      orderBy: "",
      orderType: "",
      newSendoutCaseInfo: "",
      searchCaseLoading: false,
      exportSendoutsDialogVisisble: false,
      allCases: [],
      hospitalsData: { data: [] },
      physiciansData: {},
      physiciansLoading: false,
      hospitalsLoading: false,
      pregnant: "",
      selectedHospital: [],
    };
  },
  computed: {
    checkCaseStatus() {
      return (caseData) => {
        if (caseData.status === "COMPLETE") {
          return true;
        } else {
          return false;
        }
      };
    },
    checkNewReport() {
      return (caseData) => {
        if (caseData && caseData.test_reports && caseData.test_reports.length) {
          return true;
        } else {
          return false;
        }
      };
    },

    getStatusType() {
      return (statusVal) => {
        const status = statusVal.trim();
        if (status == "ACTIVE") {
          return "default";
        } else if (status == "COMPLETE") {
          return "success";
        } else if (status == "TEST_REPORTS") {
          return "warning";
        } else if (status == "TEST_RESULTS") {
          return "info";
        } else if (status == "ARCHIVED") {
          return "danger";
        } else {
          return "";
        }
      };
    },
    ...mapGetters("sendOuts", [
      "getAllSendOuts",
      "getSendOutDeleteStatus",
      "getSendOutDeleteError",
      "getReportSyncStatus",
      "getOrderSentStatus",
    ]),
    ...mapGetters("cases", [
      "getAllCases",
      "getTestReportsDownloadLog",
      "getTestReportsViewLog",
    ]),
    ...mapGetters("hospitals", ["getAllHospitals"]),
    ...mapGetters("physicians", ["getAllPhysicians"]),
    ...mapGetters("auth", ["getAuthenticatedUser"]),
    ...mapGetters("profile", ["getProfileData"]),
    isSearchByInput() {
      return this.searchByKey.indexOf(this.searchBy) != -1 ? true : false;
    },
    getCaseTypes() {
      return (caseTypes) => {
        return (caseTypes || []).map((e) => this.caseTypeMap[e]);
      };
    },
    checkLab() {
      if (
        this.getProfileData &&
        this.getProfileData.lab &&
        this.getProfileData.lab.lab_code === "DLW"
      ) {
        return false;
      }
      return true;
    },
  },
  mounted() {
    this.setQueryParamsData();
    this.fetchAllSendOuts();
    this.loadFilterPreferences();
  },
  methods: {
    sendoutPrint(sendoutId) {
      let urlData = this.$router.resolve({
        name: "SendOutPrint",
        params: { sendout_id: sendoutId },
      });
      window.open(urlData.href, "_blank");
    },
    onViewReports(report) {
      let testReportsData = report.test_reports;
      for (let i = 0; i < testReportsData.length; i++) {
        if (
          (testReportsData[i].is_manually ||
            testReportsData[i].additional_report_merged ||
            testReportsData[i].additional_report_already_merged ||
            testReportsData[i].download_ready) &&
          testReportsData[i].mark_for_physician
        ) {
          let routerData = this.$router.resolve({
            name: "supplementaryReportView",
            params: {
              report_id: testReportsData[i]._id,
              case_id: report.case_id,
            },
          });
          window.open(routerData.href, "_blank");
        } else {
          if (testReportsData[i].mark_for_physician) {
            let routerData = this.$router.resolve({
              name: "ResultFileTestReports",
              params: {
                report_id: testReportsData[i]._id,
                case_id: report.case_id,
              },
            });
            window.open(routerData.href, "_blank");
          }
        }
        this.testReportsViewLog(report, testReportsData[i]);
        this.testReportsDownloadLog(report, testReportsData[i]);
      }
    },
    async testReportsDownloadLog(report, testReports) {
      let params = {
        case_id: report.case_id,
        report_id: testReports._id,
      };
      await this.$store.dispatch("cases/testReportsDownloadLog", params);
    },
    async testReportsViewLog(report, testReports) {
      let params = {
        case_id: report.case_id,
        report_id: testReports._id,
      };
      await this.$store.dispatch("cases/testReportsViewLog", params);
    },
    async updateScroll() {
      this.scrollPosition = window.scrollY;
    },
    goToCaseView(case_id) {
      this.$router.push({
        name: "CaseView",
        params: { case_id: case_id },
        query: { ...this.$route.query, redirectRoute: this.$route.name },
      });
    },
    async querySpuAttrNames(query) {
      try {
        if (query.length >= 3) {
          this.searchCaseLoading = true;
          let params = { search_string: query, get_all: true };
          await this.$store.dispatch("cases/fetchAllCases", params);
          this.allCases = this.getAllCases.data;
          this.searchCaseLoading = false;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async onReportsExport() {
      this.loading = true;

      this.exportSendoutsDialogVisisble = true;
      this.loading = false;
    },
    onView(caseId) {
      this.$router.push({
        name: "SendoutsInformation",
        params: { sendout_id: caseId },
        query: { ...this.$route.query, redirectRoute: this.$route.name },
      });
    },
    async onDelete(id) {
      this.$confirm("Are you sure to delete send-out?", "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      }).then(() => {
        this.deleteSendOut(id);
      });
    },
    async deleteSendOut(id) {
      try {
        await this.$store.dispatch("sendOuts/deleteSendOut", {
          send_out_id: id,
        });
        if (this.getSendOutDeleteStatus) {
          successNotification("Send-out deleted successfully");

          this.loading = true;

          await this.fetchAllSendOuts(this.page);

          this.loading = false;
        } else {
          errorNotification(
            this.getSendOutDeleteError || "Error while deleting Send-Out"
          );
        }
      } catch (error) {
        console.log(error);
      }
    },
    clearSearchBy() {
      if (this.$route.query.selectedSearchBy == "Pregnancy") {
        this.fetchAllSendOuts(1);
      }
    },
    clearAllFilters() {
      this.search_string = "";
      this.patient_name = "";
      this.selectedHospital = [];
      this.hospital = "";
      this.physician = [];
      this.date_of_birth = "";
      this.caseType = [];
      this.page = 1;
      this.fetchAllSendOuts(1);
    },
    clearInputSearch() {
      if (
        this.hospital ||
        (this.physician && this.physician.length) ||
        this.date_of_birth ||
        this.caseType.length
      ) {
        this.hospital = "";
        this.selectedHospital = [];
        this.physician = [];
        this.date_of_birth = "";
        this.caseType = [];
        this.isSearchByInput = "";
        this.page = 1;
        this.fetchAllSendOuts(1);
      }
      if (this.searchBy == "Pregnancy") {
        this.fetchAllSendOuts(1);
      }
    },
    async fetchAllPhysicians(physician) {
      try {
        this.physiciansLoading = true;
        let params = {
          get_all: true,
        };
        if (physician && typeof physician === 'string') {
          params.search_string = physician;
        }
        if (Array.isArray(this.selectedHospital) && this.selectedHospital.length === 1) {
          params.hospital = this.selectedHospital[0]._id;
        }
        await this.$store.dispatch("physicians/fetchAllPhysicians", params);
        this.physiciansData = JSON.parse(JSON.stringify(this.getAllPhysicians));
        this.physiciansLoading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async remoteMethodPhysician(query) {
      if (query !== "") {
        await this.fetchAllPhysicians(query);
      } else {
        await this.fetchAllPhysicians();
      }
    },
    onPhysicianFocus() {
      if (!this.physiciansData.data || !this.physiciansData.data.length) {
        this.fetchAllPhysicians();
      }
    },
    async remoteMethodFacility(query) {
      if (query !== "") {
        await this.fetchAllHospitals(query);
      } else {
        await this.fetchAllHospitals();
      }
    },
    onHospitalFocus() {
      if (!this.hospitalsData.data || !this.hospitalsData.data.length) {
        this.fetchAllHospitals();
      }
    },
    onHospitalChange(value) {
      const selected = Array.isArray(value) ? value : value ? [value] : [];
      this.hospital = selected.length ? selected[0]._id : "";
      this.physician = [];
      this.physiciansData = { data: [] };
      this.handleCurrentChange(1);
    },
    async fetchAllHospitals(hospital) {
      try {
        this.hospitalsLoading = true;
        let params = {
          get_all: true,
          status: "ACTIVE",
        };
        if (hospital && typeof hospital === 'string') {
          params.search_string = hospital;
        }
        await this.$store.dispatch("hospitals/fetchAllHospitals", params);
        this.hospitalsData = JSON.parse(JSON.stringify(this.getAllHospitals));
        this.hospitalsLoading = false;
      } catch (error) {
        console.log(error);
      }
    },

    setQueryParamsData() {
      this.page = this.$route.query.selectedPage
        ? parseInt(this.$route.query.selectedPage)
        : 1;
      this.pageSize = this.$route.query.selectedPageSize
        ? parseInt(this.$route.query.selectedPageSize)
        : 25;
      if (this.$route.query.selectedString) {
        this.search_string = this.$route.query.selectedString;
      }
      if (this.$route.query.selectedCase) {
        const sel = this.$route.query.selectedCase;
        this.caseType = Array.isArray(sel) ? sel : [sel];
      }
      if (this.$route.query.selectedSearchBy) {
        this.searchBy = this.$route.query.selectedSearchBy;
      }
      if (this.$route.query.selectedPhysician) {
        this.fetchAllPhysicians();
        const selPhys = this.$route.query.selectedPhysician;
        const physicianIds = Array.isArray(selPhys) ? selPhys : [selPhys];
        this.physician = physicianIds;
        if (!this.physiciansData || !Array.isArray(this.physiciansData.data)) {
          this.physiciansData = { data: [] };
        }
        physicianIds.forEach((id) => {
          if (!this.physiciansData.data.some((p) => p._id === id)) {
            this.physiciansData.data = [
              { _id: id, name: id },
              ...this.physiciansData.data,
            ];
          }
        });
      }
      if (this.$route.query.selectedHospital) {
        const rawIds = this.$route.query.selectedHospital;
        const hospitalIds = Array.isArray(rawIds) ? rawIds : [rawIds];
        const rawNames = this.$route.query.selectedHospitalName;
        const hospitalNames = Array.isArray(rawNames) ? rawNames : [rawNames];
        this.hospital = hospitalIds[0] || "";
        const existing =
          this.hospitalsData && Array.isArray(this.hospitalsData.data)
            ? this.hospitalsData.data
            : [];
        this.selectedHospital = hospitalIds.map((id, i) => {
          const found = existing.find((h) => h._id === id);
          return found || { _id: id, name: hospitalNames[i] || "" };
        });
        const missing = this.selectedHospital.filter(
          (h) => !existing.some((e) => e._id === h._id)
        );
        if (missing.length) {
          this.hospitalsData = {
            ...this.hospitalsData,
            data: [...existing, ...missing],
          };
        }
      }
      if (this.$route.query.selectedDateOfBirth) {
        this.date_of_birth = this.$route.query.selectedDateOfBirth;
      }
      if (this.$route.query.selectedOrderBy) {
        this.orderBy = this.$route.query.selectedOrderBy;
      }
      if (this.$route.query.selectedOrderType) {
        this.orderType = this.$route.query.selectedOrderType;
      }
    },
    getAutoCompleteOrders() {
      setTimeout(() => {
        this.page = 1;
        this.fetchAllSendOuts();
      }, 600);
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.page = 1;

      this.fetchAllSendOuts();
    },
    handleCurrentChange(page) {
      this.page = page;

      this.fetchAllSendOuts();
    },
    // Range guards: no future dates, and From/To can't cross each other.
    disabledFromDate(date) {
      if (date > new Date()) return true;
      if (this.toDate) return moment(date).isAfter(moment(this.toDate), "day");
      return false;
    },
    disabledToDate(date) {
      if (date > new Date()) return true;
      if (this.fromDate) return moment(date).isBefore(moment(this.fromDate), "day");
      return false;
    },
    onFromDateChange() {
      // If the current To Date is now earlier than From, clear it to avoid an invalid range.
      if (
        this.fromDate &&
        this.toDate &&
        moment(this.toDate).isBefore(moment(this.fromDate), "day")
      ) {
        this.toDate = "";
      }
      this.handleCurrentChange(1);
    },
    onChangeSort({ order, prop }) {
      if (order && prop) {
        this.orderBy = prop;
        this.orderType = order == "ascending" ? "asc" : "desc";
      } else {
        this.orderBy = "";
        this.orderType = "";
      }
      this.fetchAllSendOuts();
    },
    prepareParams() {
      this.pregnant = "";
      let params = {
        page: this.page,
        limit: this.pageSize,
      };
      if (this.search_string) {
        params.search_string = this.search_string;
      }
      if (this.patient_name) {
        params.patient_name = this.patient_name;
      }
      if (this.date_of_birth) {
        const date_of_birth = moment(this.date_of_birth).format("YYYY-MM-DD");

        params.date_of_birth = date_of_birth;
      }
      if (Array.isArray(this.selectedHospital) && this.selectedHospital.length) {
        params.hospitals = this.selectedHospital
          .map((h) => h && h._id)
          .filter(Boolean);
      }
      if (this.caseType && this.caseType.length) {
        params.case_type = this.caseType;
      }
      if (this.physician && this.physician.length) {
        params.ordering_physician = this.physician;
      }
      if (this.searchBy == "Pregnancy") {
        this.pregnant = true;
        params.pregnant = true;
      }
      if (this.orderBy && this.orderType) {
        params.order_by = this.orderBy;
        params.order_type = this.orderType;
      }
      params.status = this.selectedStatuses;
      if (this.isGowthamUser) {
        params.is_old = true;
      }
      return params;
    },
    updateQueryParams(params) {
      let selectedParams = {
        selectedPage: params.page,
        selectedCase: params.case_type,
        selectedHospital: params.hospitals,
        selectedHospitalName: Array.isArray(this.selectedHospital)
          ? this.selectedHospital.map((h) => (h && h.name) || "")
          : undefined,
        selectedDateOfBirth: params.date_of_birth,
        selectedPhysician: params.ordering_physician,
        selectedString: params.search_string,
        selectedPageSize: params.limit,
        selectedOrderBy: params.order_by,
        selectedOrderType: params.order_type,
        selectedSearchBy: this.searchBy || undefined,
      };
      this.updateQueryParam(this.$route.name, selectedParams);
    },
    async fetchAllSendOuts() {
      try {
        this.loading = true;
        let params = this.prepareParams();
        await this.$store.dispatch("sendOuts/getSendOuts", params);
        this.updateQueryParams(params);
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.filter-toggle-btn.el-button {
  width: 100px !important;
  min-width: 100px !important;
  max-width: 100px !important;
  height: 35px !important;
  min-height: 35px !important;
  max-height: 35px !important;
  padding: 0 8px !important;
  margin: 0;
  border-radius: 6.4px !important;
  border: 1px solid #dedbdb;
  background: #fff;
  color: #273480;
  cursor: pointer;
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  transition: all 0.3s ease;
  &:hover,
  &:focus {
    background: #273480;
    border-color: #273480;
    color: #fff;
  }
}
.slide-filters-enter-active,
.slide-filters-leave-active {
  transition: all 0.3s ease;
  overflow: hidden;
  max-height: 200px;
  opacity: 1;
}
.slide-filters-enter-from,
.slide-filters-leave-to {
  max-height: 0;
  opacity: 0;
  margin-top: 0 !important;
}
@mixin button-css {
  min-width: 100px;
  height: auto;
  min-height: 20px;
  padding: 6px 5px;
  color: #4bb543;
  font-size: 12px !important;
  font-weight: 500 !important;
  line-height: 1;
  letter-spacing: 0 !important;
  // border: none;
  text-align: center;
  // color: #fff;
  // background-color: #3fc380;
  border: 0.6px solid #4bb543;
  border-radius: 4px !important;
  &:hover,
  &:active,
  &:focus {
    color: #4bb543;
    // color: #fff;
    // background-color: #3fc380 !important;
    border: 0.6px solid #4bb543;
  }
}
.btn-success {
  @include button-css;
}
.btn-danger {
  @include button-css;
  color: #eb5757 !important;
  border: 0.6px solid #eb5757 !important;
  &:hover,
  &:active &:focus {
    color: #eb5757;
    border: 0.6px solid #eb5757;
  }
}

.btn-active {
  @include button-css;
  color: #5162fd !important;
  border: 0.6px solid #5162fd !important;
  &:hover,
  &:active &:focus {
    color: #5162fd;
    border: 0.6px solid #5162fd;
  }
}
.btn-processing {
  @include button-css;
  color: #f28b0c !important;
  border: 0.6px solid #f28b0c !important;
  &:hover,
  &:active,
  &:focus {
    color: #f28b0c;
    border: 0.6px solid #f28b0c;
  }
}
#all-sendOuts-list {
  .stickyNavbar {
    padding-bottom: 5px !important;
    .container-default {
      padding-top: 0;
      padding-bottom: 5px;
    }
  }
}
</style>
